import { GitHubWidget, type GitHubWidgetType } from '../../molecules/GitHubWidget/GitHubWidget'
import styles from './GitHubSection.module.css'

/* ─────────────────────────────────────────────────
   Configuration
───────────────────────────────────────────────── */

/** Nom d'utilisateur GitHub — source unique de vérité */
const GITHUB_USERNAME = 'StevenYAMBOS'

/** Ordre et types des widgets affichés */
const WIDGETS: GitHubWidgetType[] = [
  'streak',
  'contributions',
  'overview',
  'languages',
]

/* ─────────────────────────────────────────────────
   Composant
───────────────────────────────────────────────── */
export function GitHubSection() {
  return (
    <section id="github" className={styles.section} aria-labelledby="github-title">

      {/* ── En-tête ── */}
      <div className={styles.header}>
        <h2 id="github-title" className={styles.title}>
          Contributions
        </h2>
        {/* Barre décorative gradient — cohérente avec les autres sections */}
        <div className={styles.titleBar} aria-hidden="true" />
        <p className={styles.subtitle}>
          Activité et statistiques de mes contributions sur GitHub (2025-2026 je n'ai pas chômé, à moins que...).
        </p>
      </div>

      {/* ── Grille de widgets ── */}
      <ul className={styles.grid} role="list" aria-label="Widgets GitHub">
        {WIDGETS.map((type) => (
          /*
           * La key inclut le type pour que React recrée le composant
           * si l'ordre venait à changer, garantissant que les URLs
           * et les images sont bien remplacées.
           */
          <li key={type} className={styles.gridItem}>
            <GitHubWidget
              type={type}
              username={GITHUB_USERNAME}
            />
          </li>
        ))}
      </ul>

      {/* ── Lien vers le profil GitHub ── */}
      <div className={styles.profileLink}>
        <a
          href={`https://github.com/${GITHUB_USERNAME}`}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.profileBtn}
          aria-label={`Voir le profil GitHub de ${GITHUB_USERNAME}`}
        >
          {/* Icône GitHub SVG inline */}
          <svg
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
            className={styles.profileIcon}
          >
            <path d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0 1 12 6.844a9.59 9.59 0 0 1 2.504.337c1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.02 10.02 0 0 0 22 12.017C22 6.484 17.522 2 12 2z" />
          </svg>
          Voir le profil complet
        </a>
      </div>

    </section>
  )
}